// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-custom[data-v-d9bb48b0]{height:100%;min-height:165px;background-size:50%;background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
